import {
  isGeoentityOnSearchRoute,
  isSearchFiltersRoute,
  selectCurrentHistoryRouteOptions
} from '../../store/history/history.selectors'
import { routeParameterToBbox } from '../../domain/map/conversion'
import { setGeoentityInitialFilterParameters } from '../../store/geoentity/geoentitySlice'
import { getCurrentDateISO, getFutureDate } from '../../domain/utils/date'
import { searchFieldsHaveNotChanged } from '../../store/history/history.search'

export const getRouteBbox = storeState => {
  const bbox = selectCurrentHistoryRouteOptions(storeState)?.bbox
  if (bbox) return bbox

  if (__BROWSER__) {
    try {
      // TODO: NES-2038
      const bboxStr = decodeURIComponent(window.location.hash.match(/bbox=([^&]+)/)[1])
      return routeParameterToBbox(bboxStr)
    } catch (e) {}
  }
}

const hotelWithCalendar = [
  'hotel',
  'chambre-d-hotes',
  'location-gite',
  'booking',
  'accor',
  'hotelf1',
  'mercure',
  'novotel'
]

const hasCalendar = appOrRubricIds => {
  if (typeof appOrRubricIds === 'string') return hotelWithCalendar.includes(appOrRubricIds)
  return (appOrRubricIds ?? []).some(id => hotelWithCalendar.includes(id))
}

export const setInitialFilters = appOrRubricIds => (dispatch, getState) => {
  if (hasCalendar(appOrRubricIds))
    dispatch(
      setGeoentityInitialFilterParameters({
        'multidatepicker-dates': {
          from: getCurrentDateISO(getFutureDate({ days: 7 })),
          to: getCurrentDateISO(getFutureDate({ days: 8 }))
        }
      })
    )
}

export const checkIfBackFromPoiOrFilters = (routeParams, prevRoute, previousSearchParameters) =>
  searchFieldsHaveNotChanged(routeParams, previousSearchParameters) &&
  ((isGeoentityOnSearchRoute(prevRoute?.route) && searchFieldsHaveNotChanged(routeParams, prevRoute?.params)) ||
    isSearchFiltersRoute(prevRoute?.route))
